import { z } from 'zod';

// Zod probes `new Function` to speed up validation; under our strict CSP (no eval,
// Trusted Types) that probe is reported as a violation even though Zod catches it.
// jitless skips it. Imported first in main.tsx, before any schema runs.
z.config({ jitless: true });
